import { FC, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@material-ui/core';
import { AdminsTable } from '../../components/Tables';
import { useStyles } from './styles';

const Administrators: FC = observer(() => {
  const classes = useStyles();

  useEffect(() => {
    document.title = 'EasyIdentity: Admins';
  }, []);
  return (
    <Container maxWidth='xl' className={classes.container}>
      <AdminsTable />
    </Container>
  );
});

export default Administrators;
